import React from "react";
import "./RegistrationSuccess.css";

const RegistrationSuccess = ({ customerData }) => {
  const getLocalizedShipmentType = (type) => {
    return type === 'Ocean' ? 'LAUT' : 'UDARA';
  };
  return (
    <div className="success-page">
              <div className="logo-container">
  <img 
    src={process.env.PUBLIC_URL + '/assets/logo.png'} 
    alt="Hebat Cargo Logo" 
    className="company-logo"
  />
</div>
      <h1 className="customer-number">
        Nomer Customer: {customerData.customerNumber}
      </h1>

      <div className="registration-details">
        <h2>Detail Registrasi</h2>

        <section>
          <h3>Informasi Pengirim</h3>
          <p>
            <strong>Nama:</strong> {customerData.senderName}
          </p>
          <p>
            <strong>Email:</strong> {customerData.senderEmail}
          </p>
          <p>
            <strong>Alamat:</strong> {customerData.senderAddress}
          </p>
          <p>
            <strong>Kode Pos:</strong> {customerData.senderPostCode}
          </p>
          <p>
            <strong>Telpon:</strong> {customerData.senderPhone}
          </p>
          <p>
            <strong>Nomer Paspor:</strong> {customerData.senderPassportNumber}
          </p>
        </section>

        <section>
          <h3>Informasi Penerima</h3>
          <p>
            <strong>Nama:</strong> {customerData.receiverName}
          </p>
          <p>
            <strong>Alamat:</strong> {customerData.receiverAddress}
          </p>
          <p>
            <strong>Kode Pos:</strong> {customerData.receiverPostCode}
          </p>
          <p>
            <strong>Telpon:</strong> {customerData.receiverPhone}
          </p>
        </section>

        <section>
          <h3>Detail Pengiriman</h3>
          <p>
            <strong>Layanan:</strong> {getLocalizedShipmentType(customerData.shipmentType)}
          </p>
          <p>
            <strong>Jumlah Box:</strong> {customerData.amountOfBoxes}
          </p>
          <p>
            <strong>Diskripsi Barang:</strong> {customerData.itemDescriptions}
          </p>
          <p>
            <strong>Tanggal Pickup:</strong> {customerData.pickupDate}
          </p>
          <p>
            <strong>Jam Pickup:</strong> {customerData.pickupTime}
          </p>
        </section>


      </div>
    </div>
  );
};

export default RegistrationSuccess;
